'use client';

import React from 'react';
import Image from 'next/image';

interface PortfolioGalleryProps {
  title: string;
  detailImageUrl?: string | null;
  additionalPhotos?: string[];
}

export default function PortfolioGallery({
  title,
  detailImageUrl,
  additionalPhotos = [],
}: PortfolioGalleryProps) {
  // Формируем массив изображений: сначала detailImageUrl, затем additionalPhotos
  const allImages = [
    ...(detailImageUrl ? [detailImageUrl] : []),
    ...additionalPhotos,
  ].filter(Boolean);

  if (allImages.length === 0) {
    return null;
  }

  // Группируем изображения по парам для создания рядов
  const imagePairs: Array<[string, string?]> = [];
  for (let i = 0; i < allImages.length; i += 2) {
    imagePairs.push([allImages[i], allImages[i + 1]]);
  }

  return (
    <section className="mb-8 md:mb-12 w-full">
      <div className="space-y-4 md:space-y-6">
        {imagePairs.map((pair, pairIndex) => {
          const [firstImage, secondImage] = pair;
          // Чередуем порядок: четные ряды (0, 2, 4...) - первая 7/12, вторая 5/12
          // Нечетные ряды (1, 3, 5...) - первая 5/12, вторая 7/12
          const isEvenRow = pairIndex % 2 === 0;
          const firstWidth = isEvenRow ? 'md:w-7/12' : 'md:w-5/12';
          const secondWidth = isEvenRow ? 'md:w-5/12' : 'md:w-7/12';

          return (
            <div
              key={pairIndex}
              className="flex flex-col md:flex-row gap-4 md:gap-6 w-full"
            >
              {/* Первое изображение */}
              {firstImage && (
                <div
                  className={`relative overflow-hidden rounded-lg bg-gray-200 dark:bg-gray-800 w-full ${firstWidth} aspect-[16/10]`}
                >
                  <Image
                    src={firstImage}
                    alt={`${title} - изображение ${pairIndex * 2 + 1}`}
                    fill
                    className="object-cover transition-transform duration-300 hover:scale-105"
                    sizes="(max-width: 768px) 100vw, 58vw"
                    quality={75}
                  />
                </div>
              )}

              {/* Второе изображение */}
              {secondImage && (
                <div
                  className={`relative overflow-hidden rounded-lg bg-gray-200 dark:bg-gray-800 w-full ${secondWidth} aspect-[16/10]`}
                >
                  <Image
                    src={secondImage}
                    alt={`${title} - изображение ${pairIndex * 2 + 2}`}
                    fill
                    className="object-cover transition-transform duration-300 hover:scale-105"
                    sizes="(max-width: 768px) 100vw, 42vw"
                    quality={75}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}

